import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify/lib";

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore: Module Error
import colors from "../scss/_colors.scss";

import de from "vuetify/src/locale/de";
import en from "vuetify/src/locale/en";
import fr from "vuetify/src/locale/fr";
import nl from "vuetify/src/locale/nl";

Vue.use(Vuetify);

export default (i18n: VueI18n) =>
  new Vuetify({
    lang: {
      // this modification has been implemented to avoid reccurent vue-i18 warn
      // [vue-i18n] Cannot translate the value of keypath '...'. Use the value of keypath as default.
      // use translations provided by Vuetify instead of declaring "custom" translations
      // declared "custom" translations were exactly the same as those provided by Vuetify
      // t: (key, ...params) => i18n.t(key, params).toString(),
      locales: { de, en, fr, nl }, // refer to SupportedLocales in @core/i18n
      current: i18n.locale,
    },
    breakpoint: {
      thresholds: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
      },
    },
    theme: {
      options: {
        customProperties: true,
      },
      themes: {
        light: {
          primary: colors.primary,
          neutral: colors.neutral,
          secondary: colors.secondary,
          accent: colors.accent,
          error: colors.error,
          info: colors.info,
          success: colors.success,
          warning: colors.warning,
          anchor: colors.anchor,
        },
        dark: {
          primary: colors.primary,
          neutral: colors.neutral,
          secondary: colors.secondary,
          accent: colors.accent,
          error: colors.error,
          info: colors.info,
          success: colors.success,
          warning: colors.warning,
          anchor: colors.anchor,
        },
      },
    },
    icons: {
      iconfont: "fa",
    },
  });
